import {Component, OnInit} from '@angular/core';
import {ConfigService} from "./shared/services/config.service";
import {Title} from '@angular/platform-browser';
import {CurrentUserService} from './shared/services/current-user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  constructor(private titleService: Title,
              public configService: ConfigService
  ) {
  }

  ngOnInit() {
    const title = this.configService.getConfiguration().CDS_Name;
    this.titleService.setTitle(title);
    
    // ℹ️ Le chargement utilisateur se fait APRÈS le login:
    // - Dans AuthenticationService.login() après JWT reçu
    // - Ou dans CheckAuthenticationComponent après vérification du token
    // - Ou via LoadCurrentUserGuard avant accès aux routes protégées
  }

}

